import { Product } from '../interfaces/product';

/**
 * Account product list
 */
export const AccountProductList: Product[] = [
    {
        productId: 'wedding_account_full',
        productName: 'Wedding Account Full Access',
        productType: 'account',
        enable: true,
        recommended: true,
        oriPriceList: [
            { currency: 'USD', amount: 79 },
            { currency: 'SGD', amount: 99 },
            { currency: 'MYR', amount: 299 },
            { currency: 'HKD', amount: 599 },
            { currency: 'TWD', amount: 1990 }
        ],
        priceList: [
            { currency: 'USD', amount: 48 },
            { currency: 'SGD', amount: 65 },
            { currency: 'MYR', amount: 199 },
            { currency: 'HKD', amount: 375 },
            { currency: 'TWD', amount: 1500 }
        ],
        priceListNew: [
            { currency: 'USD', amount: 48 },
            { currency: 'SGD', amount: 65 },
            { currency: 'MYR', amount: 199 },
            { currency: 'HKD', amount: 375 },
            { currency: 'TWD', amount: 1500 }
        ],
        upgradePriceList: [
            { currency: 'USD', amount: 20 },
            { currency: 'SGD', amount: 25 },
            { currency: 'MYR', amount: 80 },
            { currency: 'HKD', amount: 150 },
            { currency: 'TWD', amount: 550 }
        ]
    },
    {
        productId: 'wedding_account_app',
        productName: 'Wedding Account App Access',
        productType: 'account',
        enable: true,
        recommended: false,
        oriPriceList: [
            { currency: 'USD', amount: 48 },
            { currency: 'SGD', amount: 65 },
            { currency: 'MYR', amount: 199 },
            { currency: 'HKD', amount: 375 },
            { currency: 'TWD', amount: 1500 }
        ],
        priceList: [
            { currency: 'USD', amount: 48 },
            { currency: 'SGD', amount: 65 },
            { currency: 'MYR', amount: 199 },
            { currency: 'HKD', amount: 375 },
            { currency: 'TWD', amount: 1500 }
        ],
        priceListNew: [
            { currency: 'USD', amount: 48 },
            { currency: 'SGD', amount: 65 },
            { currency: 'MYR', amount: 199 },
            { currency: 'HKD', amount: 375 },
            { currency: 'TWD', amount: 1500 }
        ]
    },
    {
        productId: 'wedding_account_web',
        productName: 'Wedding Account Web Access',
        productType: 'account',
        enable: true,
        recommended: false,
        oriPriceList: [
            { currency: 'USD', amount: 38 },
            { currency: 'SGD', amount: 55 },
            { currency: 'MYR', amount: 159 },
            { currency: 'HKD', amount: 299 },
            { currency: 'TWD', amount: 1099 }
        ],
        priceList: [
            { currency: 'USD', amount: 38 },
            { currency: 'SGD', amount: 55 },
            { currency: 'MYR', amount: 159 },
            { currency: 'HKD', amount: 299 },
            { currency: 'TWD', amount: 1099 }
        ],
        priceListNew: [
            { currency: 'USD', amount: 38 },
            { currency: 'SGD', amount: 55 },
            { currency: 'MYR', amount: 159 },
            { currency: 'HKD', amount: 299 },
            { currency: 'TWD', amount: 1099 }
        ]
    }
];

/**
 * Bulk purchase discount rate
 */
export const BulkAccountDiscount: any = {
    100: 0.5,
    50: 0.4,
    30: 0.3,
    20: 0.2,
    10: 0.1
};

/**
 * Referral discount rate
 */
export const ReferralAccountDiscount = 0.05;

/**
 * Tax rate
 */
export const TaxRate: any = {
    SGD: 0.06,
    default: 0
};
